<body id="background" class="allianz-background d-flex flex-column justify-content-between">
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
</body>
